/* eslint-disable react/no-unescaped-entities */
import React from 'react';
import { useTheme } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import BusinessCenterIcon from '@material-ui/icons/BusinessCenter';
import EmojiEventsIcon from '@material-ui/icons/EmojiEvents';
import TrendingUpIcon from '@material-ui/icons/TrendingUp';
import LightbulbIcon from '@material-ui/icons/EmojiObjects';
import PublicIcon from '@material-ui/icons/Public';
import CastConnectedIcon from '@material-ui/icons/CastConnected';

const Synopsis = () => {
  const theme = useTheme();

  const sections = [
    {
      title: 'El epicentro de la autoridad corporativa',
      body: `En el dinámico ecosistema de los negocios, la información es abundante, pero la autoridad es un activo escaso. TNO Business surge como la plataforma de referencia para el sector empresarial en Venezuela, un espacio donde líderes, directivos y emprendedores de alto impacto se conectan para definir las tendencias que están transformando el mercado actual.`,
    },
    {
      title: 'Donde las ideas se convierten en estrategia',
      body: `Más que un programa de entrevistas, es una cátedra de visión corporativa. A través de un análisis profundo de la coyuntura económica y el estudio de casos de éxito, TNO Business disecciona las oportunidades de innovación y los desafíos del entorno global. Es el punto de encuentro donde el know-how de los expertos se traduce en herramientas accionables para una audiencia profesional que busca liderazgo y crecimiento sostenido.`,
    },
    {
      title: 'Tecnología al servicio de los negocios',
      body: `Impulsado por la vanguardia de TNO Media Lab, el programa ofrece una experiencia multiplataforma 360°. Cada conversación es documentada con una estética cinematográfica y una calidad técnica superior, garantizando que el mensaje de nuestros invitados proyecte la solidez y el prestigio que sus marcas representan.`,
    },
    {
      title: 'Omnicanalidad y conexión real',
      body: `A través del ecosistema de TNO, el contenido de TNO Business trasciende la pantalla para vivir en todo nuestro universo digital: desde el streaming en vivo y el formato On-Demand, hasta las crónicas especializadas de TNO Digest. Es la vitrina de mayor credibilidad para quienes buscan validar su posicionamiento y conectarse con el futuro de los negocios.`,
    },
  ];

  return (
    <Box mt={4}>
      <Typography
        variant="h5"
        component="h2"
        align="center"
        gutterBottom
        sx={{ fontWeight: 700 }}
      >
        TNO Business: El epicentro de la autoridad corporativa
      </Typography>
      <Typography
        variant="body1"
        color="textSecondary"
        align="center"
        sx={{ maxWidth: 900, mx: 'auto', mb: 4 }}
      >
        En TNO Business, las conversaciones no son solo contenido: son puntos de
        referencia para una nueva generación de líderes que entiende que la
        evolución de los mercados comienza con una conexión.
      </Typography>

      <Grid container spacing={3}>
        {sections.map((section) => (
          <Grid item xs={12} md={6} key={section.title}>
            <Card
              elevation={3}
              sx={{
                height: '100%',
                borderRadius: 3,
                bgcolor:
                  theme.palette.mode === 'dark'
                    ? 'background.default'
                    : 'background.paper',
              }}
            >
              <CardContent>
                <Typography
                  variant="subtitle1"
                  sx={{ fontWeight: 700, mb: 1 }}
                >
                  {section.title}
                </Typography>

                <Box
                  display="flex"
                  alignItems="center"
                  mb={1.5}
                  sx={{ columnGap: 2, flexWrap: 'wrap' }}
                >
                  {section.title === 'El epicentro de la autoridad corporativa' && (
                    <>
                      <Box display="flex" alignItems="center" columnGap={0.5}>
                        <BusinessCenterIcon color="primary" fontSize="small" />
                        <Typography variant="caption" color="textSecondary">
                          C-Suite
                        </Typography>
                      </Box>
                      <Box display="flex" alignItems="center" columnGap={0.5}>
                        <EmojiEventsIcon color="primary" fontSize="small" />
                        <Typography variant="caption" color="textSecondary">
                          Autoridad
                        </Typography>
                      </Box>
                      <Box display="flex" alignItems="center" columnGap={0.5}>
                        <TrendingUpIcon color="primary" fontSize="small" />
                        <Typography variant="caption" color="textSecondary">
                          Crecimiento
                        </Typography>
                      </Box>
                    </>
                  )}

                  {section.title === 'Donde las ideas se convierten en estrategia' && (
                    <>
                      <Box display="flex" alignItems="center" columnGap={0.5}>
                        <LightbulbIcon color="primary" fontSize="small" />
                        <Typography variant="caption" color="textSecondary">
                          Ideas
                        </Typography>
                      </Box>
                      <Box display="flex" alignItems="center" columnGap={0.5}>
                        <EmojiEventsIcon color="primary" fontSize="small" />
                        <Typography variant="caption" color="textSecondary">
                          Casos de éxito
                        </Typography>
                      </Box>
                    </>
                  )}

                  {section.title === 'Tecnología al servicio de los negocios' && (
                    <>
                      <Box display="flex" alignItems="center" columnGap={0.5}>
                        <CastConnectedIcon color="primary" fontSize="small" />
                        <Typography variant="caption" color="textSecondary">
                          Media Lab
                        </Typography>
                      </Box>
                      <Box display="flex" alignItems="center" columnGap={0.5}>
                        <TrendingUpIcon color="primary" fontSize="small" />
                        <Typography variant="caption" color="textSecondary">
                          Experiencia 360°
                        </Typography>
                      </Box>
                    </>
                  )}

                  {section.title === 'Omnicanalidad y conexión real' && (
                    <>
                      <Box display="flex" alignItems="center" columnGap={0.5}>
                        <PublicIcon color="primary" fontSize="small" />
                        <Typography variant="caption" color="textSecondary">
                          Alcance global
                        </Typography>
                      </Box>
                      <Box display="flex" alignItems="center" columnGap={0.5}>
                        <TrendingUpIcon color="primary" fontSize="small" />
                        <Typography variant="caption" color="textSecondary">
                          Omnicanal
                        </Typography>
                      </Box>
                    </>
                  )}
                </Box>

                <Typography variant="body2" color="textSecondary">
                  {section.body}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      <Box mt={4}>
        <Typography
          variant="subtitle1"
          align="center"
          sx={{ fontStyle: 'italic' }}
        >
          TNO Business: La evolución de los mercados comienza con una conexión.
        </Typography>
      </Box>
    </Box>
  );
};

export default Synopsis;

